<template>
  <main class="page-main">
    <div class="uk-grid" data-uk-grid>
      <!-- 左侧主要内容 -->
      <div class="uk-width-2-3@l">
        <div class="widjet --steps">
          <div class="widjet__head">
            <h3 class="uk-text-lead">快速指南</h3>
          </div>
          <div class="widjet__body">
            <div class="guide-section">
              <!-- 1. 下载客户端 -->
              <div class="section">
                <h1 class="section-title">1. 下载客户端</h1>
                <p class="step">
                  <a href="https://study.s3.bitiful.net/newtop%2Ffull-sulian-top1.01.apk" class="download-btn">
                    【最新版点击下载】
                  </a>
                </p>
                <p class="step">
                  <a href="https://study.s3.bitiful.net/newtop%2Forigin-sulian-top.apk" class="download-btn">
                    【兼容版下载地址】
                  </a>
                </p>
              </div>

              <!-- 2. 注册登录 -->
              <div class="section">
                <h1 class="section-title">2. 注册登录</h1>
                <p class="info-text">（账号独立使用，稳定、安全）</p>
                <img src="@/assets/img/s安卓12.jpg" alt="注册登录" class="guide-img" />
              </div>

              <!-- 3. 兑换优惠券码 -->
              <div class="section">
                <h1 class="section-title">3. 兑换优惠券码</h1>
                <img src="@/assets/img/bm-app3_07-2.jpg" alt="兑换步骤" class="guide-img" />
                <img src="@/assets/img/安卓34.jpg" alt="兑换示例" class="guide-img" />
              </div>

              <!-- 4. 连接网络 -->
              <div class="section">
                <h1 class="section-title">4. 连接网络</h1>
                <img src="@/assets/img/安卓56.jpg" alt="网络连接" class="guide-img" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧附加内容 -->
      <div class="uk-width-1-3@l">
        <div class="widjet --support">
          <div class="widjet__head">
            <h3 class="uk-text-lead">测试 & 常见问题</h3>
          </div>
          <div class="widjet__body">
            <p class="support-text">
              <strong>点</strong>
              <a href="http://google.com/" target="_blank" class="test-link">google.com</a>
              打开网址测试，能使用说明线路连接成功，开始快乐看世界~
            </p>
            <img src="@/assets/img/20241030214336CoQD.jpg" alt="测试截图" class="guide-img" />
            <img src="@/assets/img/20241030214338Htdi.png" alt="测试示例" class="guide-img" />

            <h3 class="faq-title">安卓如何下载国外软件</h3>
            <p>需要开着本加速器下载，下载地址：</p>
            <p>
              <a href="https://cn.uptodown.com/android/download" target="_blank" class="faq-link">
                https://cn.uptodown.com/android/download
              </a>
            </p>

            <h3 class="faq-title">TikTok用不了？</h3>
            <p>TikTok对国区有限制，需特殊操作，建议在谷歌或油管搜索最新教程。</p>
            <p>安卓端建议直接网页访问
              <a href="https://www.tiktok.com/" target="_blank" class="faq-link">www.tiktok.com</a>
            </p>

            <h4>解决方案：</h4>
            <ul class="faq-list">
              <li>1. 拔掉手机卡（插上就看不了）</li>
              <li>2. 手机设置 → 通用 → 语言与地区 → 选择美国</li>
              <li>3. 选择 **美国线路**（1~10）</li>
              <li>4. **重启设备**，连接节点，成功访问 TikTok</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "SubscriptionGuide",
};
</script>

<style scoped>
/* 🌟 页面整体布局 */
.page-main {
  width: 100%;
  padding: 20px;
  background: #f9f9f9;
}

/* 🌟 主要内容区 */
.widjet {
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.widjet__head h3 {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 15px;
}

/* 🌟 标题样式 */
.section {
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 2px solid #ddd;
}

.section-title {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 15px;
}

/* 🌟 下载按钮 */
.download-btn {
  display: inline-block;
  padding: 8px 15px;
  font-size: 16px;
  font-weight: bold;
  color: white;
  background-color: rgb(192, 0, 0);
  text-decoration: none;
  border-radius: 5px;
  transition: background 0.3s;
}

.download-btn:hover {
  background-color: rgb(150, 0, 0);
}

/* 🌟 图片样式 */
.guide-img {
  width: 100%;
  max-width: 900px;
  height: auto;
  margin: 15px 0;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

/* 🌟 常见问题 */
.faq-title {
  font-size: 18px;
  font-weight: bold;
  color: rgb(54, 113, 185);
  margin-top: 20px;
}

.faq-link {
  color: rgb(0, 112, 192);
  text-decoration: none;
}

.faq-link:hover {
  text-decoration: underline;
}

.faq-list {
  margin: 10px 0;
  padding-left: 20px;
}
</style>
